import { render, staticRenderFns } from "./EventPublishing.vue?vue&type=template&id=3c653c9e&scoped=true&"
import script from "./EventPublishing.vue?vue&type=script&lang=js&"
export * from "./EventPublishing.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3c653c9e",
  null
  
)

export default component.exports